// electric-charge.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = "Kalkulator Muatan Listrik - Menghitung Besar Muatan Listrik";
const DESCRIPTION =
  "Kalkulator muatan listrik digunakan untuk menghitung besar muatan listrik pada dua bola bermuatan menggunakan hukum Coulomb untuk interaksi listrik.";
const KEYWORDS = "muatan listrik, hukum Coulomb, menghitung muatan listrik";
const OG_URL = "https://do-calculate.com/calculator/id/electric-charge";
function ElectricChargeCalculator() {
  const [force, setForce] = useState("");
  const [distance, setDistance] = useState("");
  const [chargeMagnitude, setChargeMagnitude] = useState("");
  const [error, setError] = useState("");
  const handleCalculate = () => {
    if (!force || !distance) {
      setError("Harap masukkan gaya dan jarak dengan benar");
      setChargeMagnitude("");
      return;
    }
    const electrostaticConstant = 8.99e9;
    const forceValue = parseFloat(force);
    const distanceValue = parseFloat(distance);
    if (isNaN(forceValue) || isNaN(distanceValue)) {
      setError("Harap masukkan nilai angka yang valid");
      setChargeMagnitude("");
      return;
    }
    const chargeMagnitudeValue = Math.sqrt(
      (forceValue * distanceValue ** 2) / electrostaticConstant
    );
    setChargeMagnitude(
      `Gaya interaksi antar muatan: ${forceValue} Newton <br/>
            Jarak antar muatan: ${distanceValue} meter <br/>
            Muatan listrik pada setiap bola: ${chargeMagnitudeValue.toFixed(
              2
            )} Coulomb <br/>
            (Catatan: Muatan dihitung berdasarkan hukum Coulomb untuk interaksi listrik)`
    );
    setError("");
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <h2 style={{ fontSize: "18px" }}>
                  Cara Menghitung Muatan Listrik
                </h2>
                <p>
                  Anda dapat menggunakan kalkulator ini untuk menghitung besar muatan listrik pada
                  dua bola bermuatan menggunakan hukum Coulomb untuk interaksi listrik.
                </p>
                <p>
                  Gaya = (Konstanta elektrostatik × |Muatan pertama × Muatan kedua|) / (Jarak²)
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div >
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">Gaya (Newton)</label>
                      </b>
                      <input
                        type="number"
                        placeholder="Gaya interaksi"
                        value={force}
                        onChange={(e) => setForce(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">Jarak (meter)</label>
                      </b>
                      <input
                        type="number"
                        placeholder="Jarak antar muatan"
                        value={distance}
                        onChange={(e) => setDistance(e.target.value)}
                        className="form-control"
                        style={{ width: "200px" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      Hitung Muatan Listrik
                    </button>
                  </div>
                  <br />
                  <div>
                    {error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        Kesalahan: {error}
                      </p>
                    ) : (
                      <>
                        {chargeMagnitude !== "" && (
                          <>
                            <p className="p-3 mb-2 bg-success text-white">
                              Hasil:
                            </p>
                            <p
                              className="p-3 mb-2 bg-info text-black"
                              dangerouslySetInnerHTML={{
                                __html: chargeMagnitude,
                              }}
                            ></p>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
         </div>
</div>
  );
}
export default ElectricChargeCalculator;